module.exports = __webpack_public_path__ + "static/media/timeline-dark.1f3ddaa6.svg";